import UseSwr from "@/core/composables/swr/useSwr";
import {OrderIndex} from "@/order/interfaces/Order";
import {computed, Ref} from "vue";
import {cacheKey} from "@/lib/cache";
import {PaginatedData} from "@/core/interfaces/api";
import {orderApi} from "@/container";

const useOrders = ({page, limit}: { page: Ref<number>; limit: number; }) => {
    const {
        data,
        isLoading,
        error,
        mutate
    } = UseSwr<PaginatedData<OrderIndex[]>>(
        computed(() => cacheKey('orders', {page: page.value, limit})),
        () => orderApi().index({page: page.value, limit})
    );

    return {
        data: computed(() => data.value?.data || []),
        meta: computed(() => data.value?.meta || {last_page: 0}),
        isLoading,
        error,
        mutate
    };
};

export default useOrders;
